import type { FeatureFlagConfig } from '@platform/client/features';

declare module '@platform/core/feature-flags' {
  interface FeatureFlags {
    // S2CX-374: Allow customers to manager their escalation configs
    SELF_SERVE_ESCALATIONS?: boolean;
  }
}

export default {
  featureFlags: {
    SELF_SERVE_ESCALATIONS: undefined,
  },
} satisfies FeatureFlagConfig;
